import React from "react";
import PropTypes from "prop-types";
import { useIntl } from '../../../plugins/publicis-gatsby-plugin-i18n';

import {
  ArrowIconGoRight,
  ArrowIconGoLeft
} from '../Icons/Icons'

import "./ArrowButton.scss";
var classNames = require('classnames');

const ArrowButton = ({ direction, text, disabled, callback, textColor }) => {
  const intl = useIntl();
  return (
    <button
      className={classNames('button', direction, { 'disabled': disabled }, textColor)}
      onClick={() => callback()}
      aria-label={direction === 'prev' ? intl.formatMessage({ id: 'ariaLabel.slider_arrow_prev' }) : intl.formatMessage({ id: 'ariaLabel.slider_arrow_next' })} >
      {
        direction === 'prev' ? (
          <ArrowIconGoLeft />
        ) : (
          <ArrowIconGoRight />
        )
      }
      <span aria-label={direction === 'prev' ? intl.formatMessage({ id: 'ariaLabel.slider_arrow_prev' }) : intl.formatMessage({ id: 'ariaLabel.slider_arrow_next' })}>{text}</span>
    </button>
  );
};

ArrowButton.propTypes = {
  text: PropTypes.string,
  direction: PropTypes.string
};

ArrowButton.defaultProps = {
  direction: "right",
  text: "Next",
};

export default ArrowButton;
